// extracted by mini-css-extract-plugin
export default {"message":"notificationMessage_message__jTB6V","label":"notificationMessage_label__rVw1A","list":"notificationMessage_list__uJK9x","collapsed":"notificationMessage_collapsed__kK4CH"};